import { RadioButton } from '@aqarmap/aqarmap-ui';

type PaymentOptionProps = {
  checked: boolean;
  onClick?: () => void;
  radioName: string;
  title: React.ReactNode;
  rightContent?: React.ReactNode;
  className?: string;
  disabled?: boolean;
};

export default function PaymentOption({
  checked,
  onClick,
  radioName,
  title,
  rightContent,
  className = '',
  disabled = false,
}: PaymentOptionProps) {
  return (
    <div
      className={` w-full ${className}`}
      onClick={disabled ? undefined : onClick}
    >
      <div className="flex justify-between p-0 element-center min-h-[24px] w-full">
        <div className="flex gap-2x w-full">
          <RadioButton
            field={{ name: radioName, checked, disabled }}
            size="medium"
            wrapperClassName="add-card-checkbox self-start !w-[24px]"
          />
          {title}
        </div>
        {rightContent && (
          <div className="flex element-center">{rightContent}</div>
        )}
      </div>
    </div>
  );
}
